import { getUrlParam, guidGenerator } from 'core';
import { useTranslate } from 'core/hooks/useTranslate';
import LayoutDefault from 'core/layout/LayoutDefault';
import { normalizeSsoPortalUrl } from 'core/utils/ssoPortal';
import { Icon } from 'ui';
import React from 'react';

import { ROUTES } from 'app/utils/constants/paths';

function SamlError() {
  const { t } = useTranslate();
  let username = getUrlParam('username');

  function onCloseSession() {
    if (document.cookie.indexOf('PHPSESSID') !== -1) document.cookie = 'PHPSESSID=' + guidGenerator() + '; Path=/;';
    // El referer llega por la URL de una ruta pública: sin validar, un `javascript:` se ejecutaba aquí (TAN-12449).
    globalThis.location.href = normalizeSsoPortalUrl(getUrlParam('referer')) ?? ROUTES.LOGOUT;
  }

  return (
    <LayoutDefault>
      <div className="saml-error__wrapper">
        <div className="saml-error_header">
          <button className="saml-error__close-session" onClick={onCloseSession} type="button">
            <span className="saml-error__close-session-icon">
              <Icon name="exit" color="primary" />
            </span>
            <span className="saml-error__close-session-text">{t('dropdow-profile:Sign out')}</span>
          </button>
        </div>
        <h1 className="saml-error__text">{t('login:Error saml sync alfa', { name: username })}</h1>
        <div></div>
      </div>
    </LayoutDefault>
  );
}

export default SamlError;
